import styles from "../alerts.module.css";
import { useHistory } from "react-router-dom";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import { Dropdown } from "react-bootstrap";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        maxWidth: 300,
        fontSize: 13,
        textAlign: 'left',
    },
}));

const AlertCard = ({ item, setShowdeletePopup, setSelectecId }) => {
    const redirect = useHistory();
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.ProspectCard}`} style={{ cursor: 'pointer' }} onClick={(e) => {
        if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("communityboard:update") > -1) {
            redirect.push('/resources/community-boards/edit/' + item?.id);
        } else {
            return false;
        }
    }}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("communityboard:update") > -1 || user["https://propertydek.com/permissions"].indexOf("communityboard:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic"><MoreVertical /></Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        {user["https://propertydek.com/permissions"].indexOf("communityboard:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { redirect.push('/resources/community-boards/edit/' + item?.id); }}><Edit /> Edit</Dropdown.Item>}
                        {user["https://propertydek.com/permissions"].indexOf("communityboard:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setShowdeletePopup(true); setSelectecId(item?.id); }}><Trash2 /> Delete</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>}
                <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/community-alert.svg" className={`${styles.ProspectCardImg}`} alt="" />
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.title}</span>
                    </p>
                    <p className={`${styles.ProsUserName}`}>{item?.author_name}</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Valid On:</p>
                        <p className={`${styles.Content}`}>{dayjs(item?.start_date).format('MMM D, YYYY')} to {dayjs(item?.end_date).format('MMM D, YYYY')}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Property:</p>
                        <p className={`${styles.Content}`}>
                            {item?.property_names.slice(0, 2).join(', ')}
                            {item?.property_names?.length > 2 && <BootstrapTooltip title={item?.property_names.join(', ')}>
                                <span className={`${styles.MorePropertyBU}`}>+{item?.property_names?.length - 2}</span>
                            </BootstrapTooltip>}
                        </p>
                    </li>
                </ul>
            </div>
            <div className={`${styles.TemplateCardFoot}`}>
                <p className={`${styles.LeaseConDate}`}>{dayjs(item?.updated_at).fromNow()}</p>
                {item?.is_published === 0 && <span className={`${styles.UnublishBadge}`}>Draft</span>}
                {item?.is_published === 1 && item?.status === 2 && <span className={`${styles.UpcomingBadge}`}>Upcoming</span>}
                {item?.is_published === 1 && item?.status === 1 && <span className={`${styles.ActiveBadge}`}>Active</span>}
                {item?.is_published === 1 && item?.status === 0 && <span className={`${styles.ExpiredBadge}`}>Expired</span>}
            </div>
        </div>
    </div>)
}

export default AlertCard;